module.exports = "<div fxLayoutAlign=\"center center\">\n    <ul>\n        <h1 class=\"center_text\">Article Page Space</h1>\n    </ul>  \n  </div>"